import { render, staticRenderFns } from "./RegularTaskCell.vue?vue&type=template&id=2177c924&scoped=true"
import script from "./RegularTaskCell.vue?vue&type=script&lang=js"
export * from "./RegularTaskCell.vue?vue&type=script&lang=js"
import style0 from "./RegularTaskCell.vue?vue&type=style&index=0&id=2177c924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2177c924",
  null
  
)

export default component.exports